<template>
    <v-dialog-old @hidden="resetData" :onCloseEsc="close" ref="importCompetitorsDialog" class="glue" :special-styles="{ width: '650px' }">
        <v-dialog-old @hidden="close" :onCloseEsc="close" ref="okDialog" class="glue">

            <strong v-if="!errors.length && metrics.countWriteLines > 0" >Загружено строк: {{ metrics.countWriteLines }} из {{metrics.countLines}}</strong>
            <strong v-else >Клиники не обновлены</strong>

            <br/>
            <div v-if="errors" >
                <strong v-for="error in errors" >Ошибка: {{ error.title }}<br/></strong>
            </div>

            <br/>
            <div v-if="warnings" >
                <div v-for="warning in warnings">
                    <strong>Строка: {{ warning[0].rowIndex }}<br/></strong>
                    <strong style="margin-left: 25px" v-for="warn in warning">{{ warn.title }}<br/></strong>
                    <br/>
                </div>
            </div>

            <footer><button @click="close" class="green btn-norm" type="submit">OK</button></footer>
        </v-dialog-old>
        <ValidationObserver ref="validator">
            <form>
                <drag-and-drop @fileDropped="filePrepare">
                    <fieldset>
                        <legend>Импорт URL конкурентов</legend>
                        <div v-if="file.formData === ''"  class="dropper-box"  >
                            <button class="button-add-file" @click.prevent="showFileChooser"><i class="far fa-folder-open" aria-hidden="true"/> Добавьте файл...</button>
                            <div id="dropZoneContainer">
                                <div>Перетяните файл сюда</div>
                            </div>
                        </div>
                        <div v-else>
                            <label>Файл</label>
                            <v-input v-model="file.name" disabled @clearData="clearFileData"/>
                        </div>
                    </fieldset>
                </drag-and-drop>
            </form>
        </ValidationObserver>
        <template v-slot:footer>
            <v-loading-component @click="importStart">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: canImportStart && !btnDisabled}, loadingClass]" :disabled="btnDisabled">
                        Импортировать
                    </button>
                </template>
            </v-loading-component>
        </template>
        <input type="file"
               style="display: none"
               :accept="allowedTypes.join(',')"
               ref="uploadInput"
               @input="fileChoose"
        />
    </v-dialog-old>
</template>
<script>
import dragAndDrop from '@base/DragAndDrop.vue';

export default {
    components: {
        dragAndDrop
    },
    data(){
        return{
            errors:[],
            warnings:[],
            file: {
                name: '',
                formData: ''
            },
            btnDisabled: false,
            allowedTypes: [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ],
            metrics:{
                countWriteLines:0,
                countLines:0
            }

        }
    },
    methods:{
        show() {
            this.$refs.importCompetitorsDialog.show()
        },
        close() {
            this.resetData();
            this.$refs.importCompetitorsDialog.hide();
        },
        resetData(){
            this.file = {
                name: '',
                formData: ''
            };
            this.btnDisabled = false;
        },
        clearFileData(){
            this.$refs.uploadInput.value = '';
            this.file = {
                name: '',
                formData: ''
            }
        },
        importStart(btn){
            if(!this.canImportStart || this.btnDisabled){
                return;
            }
            this.btnDisabled = true;
            btn.startLoadingAnimation();
            this.axios.post('tools/uploadImportCompetitorsFile', this.file.formData)
                .then((response) => {
                    this.metrics.countWriteLines = response.data.countWriteLines? response.data.countWriteLines : null
                    this.metrics.countLines = response.data.countLines? response.data.countLines : null
                    this.errors = response.data.errors ? response.data.errors : null
                    this.warnings = response.data.warnings ? response.data.warnings : null
                    this.$refs.okDialog.show()
                    this.btnDisabled = false;
                    btn.stopLoadingAnimation()
                });
        },
        tooltipTemplate ()  {
            return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
        },
        showFileChooser() {
            setTimeout(() => {
                this.$refs.uploadInput.click();
            }, 50)
        },
        fileChoose(event){
            if (event.target.files.length) {
                this.filePrepare(event.target.files[0])
            }
        },
        filePrepare(file) {
            if(this.allowedTypes.indexOf(file.type) === -1 ){
                this.$root.showErrorDialog({
                    message: 'Некорректный тип файла!'
                });
                return;
            }
            let reader = new FileReader();
            this.file.name = file.name
            let formData = new FormData();
            formData.append('competitors', file)
            this.file.formData = formData;

            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
    },
    computed: {
        canImportStart() {
            return this.file.formData !== '' && this.clinic_name !== ''
        }
    },
    watch: {
        'file.name': function (newVal) {
            if(newVal === ''){
                this.file.formData = '';
            }
        },
    }
}
</script>
